import { Dispatch } from 'react';
import { PayloadAction } from 'typesafe-actions';
import { createContext } from 'use-context-selector';
import { CardActionContextActionTypes, CardActionState } from './types';
import { defaultCardActionProviderState } from './defaultState';

const CardActionsContext = createContext<CardActionState>(defaultCardActionProviderState);
const CardActionsDispatchContext = createContext<
  Dispatch<PayloadAction<CardActionContextActionTypes, any>> | undefined
>(undefined);

export { CardActionsContext, CardActionsDispatchContext };
